// src/pages/Auth/Login.tsx
import { useMemo } from "react";

import { LoginView } from "./LoginView";
import { useLoginController } from "./useLoginController";

import { formatNationalNumber } from "@/utils/phone";

export default function LoginCardRedux() {
  const controller = useLoginController();

  // Grouped the way the selected country writes its own numbers, rather than always in India's
  // 5-5 split — libphonenumber knows each country's convention.
  const formattedPhone = useMemo(
    () => formatNationalNumber(controller.phone, controller.country),
    [controller.phone, controller.country],
  );

  return <LoginView {...controller} formattedPhone={formattedPhone} />;
}
